export default "__VITE_ASSET__BwPVRoq4__"